import { DataBean } from "../DataBean";

export class SolicitudReclutamiento extends DataBean {

  public async getSolicitudReclutamiento(idsolicitudreclutamiento: number): Promise<any> {
    return this.getCustomService("TalentERP", "com.orange.people.talent.bean.SolicitudReclutamiento_getSolicitudReclutamiento_Number",
      [idsolicitudreclutamiento]
    );
  }

  public async getSolicitudReclutamientoCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService("TalentERP", "java.util.List_getSolicitudReclutamientoCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteSolicitudReclutamiento(idsolicitudreclutamiento: number): Promise<any> {
    return this.getCustomService("TalentERP", "boolean_deleteSolicitudReclutamiento_Number",
      [idsolicitudreclutamiento]
    );
  }

  public async updateSolicitudReclutamiento(bean: any): Promise<any> {
    return this.getCustomService("TalentERP", "com.orange.people.talent.bean.SolicitudReclutamiento_updateSolicitudReclutamiento_com.orange.people.talent.bean.SolicitudReclutamiento",
      [
        {
          "DataBeanProperties": bean,
          "DataBeanName": "com.orange.people.talent.bean.SolicitudReclutamiento"
        }
      ]
    );
  }

}
